const initialValues = (userNickName, userProfile) => ({
    NickName: userNickName,
    UserProfile: userProfile,
});
export default initialValues;
